import React from "react";
import { HREF } from "../../db";
import { Link } from "react-router-dom";

function Recreation() {
  return (
    <React.Fragment>
      <div className="local fl">
        <h3>组内风采</h3>
        <div className="dqwz fr">
          当前位置：
          <Link to={HREF.INDEX}>主页</Link>
          &gt;
          <Link to={HREF.OTHERS}>组内风采</Link>
          &gt;
          <Link to={HREF.OTHERS_RECREATION}>课余生活</Link>
        </div>
      </div>
      <div className="cy-title fl">
        <ul>
          <li>
            <Link to={HREF.OTHERS_RECREATION} className="ej-current">
              课余生活
            </Link>
          </li>
          <li>
            <Link to={HREF.OTHERS_LINK}>链接</Link>
          </li>
        </ul>
      </div>
      <div className="content fl">
        <div className="content-con fl" id="vsb_content">
          <div className="vsb_content">
            <div style={{ justifyContent: "center", display: "flex", margin: "2em 4em" }}>
              <img style={{ width: "50%" }} src="/images/recreation/20211016/1.jpg"/>
              <img style={{ width: "50%", paddingLeft: "2em" }} src="/images/recreation/20211016/2.jpg"/>
            </div>
            <div style={{ justifyContent: "center", display: "flex", margin: "2em 4em" }}>
              <img style={{ width: "50%" }} src="/images/recreation/20211016/3.jpg"/>
              <img style={{ width: "50%", paddingLeft: "2em" }} src="/images/recreation/20211016/4.jpg"/>
            </div>
            <div style={{ justifyContent: "center", display: "flex", margin: "2em 4em" }}>
              <img style={{ width: "60%" }} src="/images/recreation/20211016/5.jpg"/>
              <img style={{ width: "40%", paddingLeft: "2em" }} src="/images/recreation/20211016/6.jpg"/>
            </div>
            <div style={{ justifyContent: "center", display: "flex", margin: "2em 4em" }}>
              <img style={{ width: "50%" }} src="/images/recreation/20211016/7.jpg"/>
              
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export { Recreation };
